module.exports = __webpack_public_path__ + "static/media/twitter.56c0477e.svg";